


























































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	toRef,
	watchEffect,
} from '@vue/composition-api';
import BaseDivider from '@front-app/components/layouts/BaseDivider.vue';
import DeclineGroupInvitation from '@front-app/modules/group/components/DeclineGroupInvitation.vue';
import GroupPageColumnInvitedWrongUser from '@front-app/modules/group/components/layouts/GroupPageColumnInvitedWrongUser.vue';
import LimitedAccess from '@front-app/modules/group/components/layouts/LimitedAccess.vue';
import ProfessionalsOnly from '@front-app/modules/group/components/layouts/ProfessionalsOnly.vue';
import TrAccessCode from '@front-app/modules/group/components/layouts/TrAccessCode.vue';
import TrModal from '@front-app/components/modals/TrModal.vue';
import TrTerms from '@front-app/modules/group/components/layouts/TrTerms.vue';
import {
	canSeeLimitedPreview,
	canSeeJoinLink,
	showProfessionalRoleRequiredPage,
	useUserMustAcceptGroupTerms,
	userMustSharePersonalInformation,
	userMustEnterAccessCode,
} from '@front-app/util/permission';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { LOADING_IMAGE } from '@front-app/store/modules/image';
import { Routes } from '@front-app/constants/routes';
import { useGroupMembershipRole } from '@front-app/hooks/useMembershipRole';

export default defineComponent({
	components: {
		BaseDivider,
		DeclineGroupInvitation,
		GroupPageColumnInvitedWrongUser,
		LimitedAccess,
		ProfessionalsOnly,
		TrAccessCode,
		TrModal,
		TrTerms,
	},
	props: {
		inviteId: {
			type: String,
			default: '',
		},
		group: {
			type: Object as PropType<GroupWithCommunity | undefined>,
			required: true,
		},
		isJoiningGroup: Boolean,
		invalidInviteEmail: Boolean,
	},
	setup(props, ctx) {
		const group = toRef(props, 'group');
		const accessCodeRequiredForUser = computed(() => userMustEnterAccessCode(group.value, CurrentUserStore.isCsr.value));
		const professionalRoleRequiredForUser = computed(() => showProfessionalRoleRequiredPage(props.group));
		const showLimitedPreview = computed(() => group.value && canSeeLimitedPreview(group.value));
		const showJoinLink = computed(() => group.value && canSeeJoinLink(group.value));
		const termsAcceptanceRequiredForUser: Ref<boolean> = useUserMustAcceptGroupTerms(group);
		const sharePersonalInformationRequiredForUser = computed(() => userMustSharePersonalInformation(group.value, CurrentUserStore.isCsr.value));
		const modalIsVisible = computed(() => professionalRoleRequiredForUser.value
			|| accessCodeRequiredForUser.value
			|| termsAcceptanceRequiredForUser.value
			|| sharePersonalInformationRequiredForUser.value
			|| showLimitedPreview.value
			|| showJoinLink.value);

		const returnToGroupsList = () => {
			ctx.root.$router.push({ name: Routes.GROUPS });
		};

		const canDeclineInvitation = computed(() => props.group && useGroupMembershipRole(props.group.role).isInvitee);

		// Group logo
		watchEffect(() => {
			const id = props.group?.id;
			if (id) {
				GroupsLogoStore.fetch(props.group.id);
			}
		});
		const logo = computed(() => {
			const id = props.group?.id;
			if (!id) {
				return LOADING_IMAGE;
			}
			return GroupsLogoStore.get(id);
		});
		// END Group logo

		return {
			canDeclineInvitation,
			modalIsVisible,
			professionalRoleRequiredForUser,
			termsAcceptanceRequiredForUser,
			sharePersonalInformationRequiredForUser,
			accessCodeRequiredForUser,
			showLimitedPreview,
			showJoinLink,
			returnToGroupsList,
			// Logo
			logo,
		};
	},
});
